import script from "./station-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./station-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./station-form-drawer.vue?vue&type=style&index=0&id=3d8a0046&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d8a0046"]])

export default __exports__